import { Alert, Box, Button, Container, Dialog, Grid, Link, Snackbar, Typography } from '@mui/material';
import msg from '@app/assets/message.svg';
import React, { FC, useEffect } from 'react';
import { ValidationCode } from '@components/ValidatePhone/ValidationCode';

interface ValidatePhoneNumberProps {
  validateCode(code: string): void;
  onResendCode(): void;
  onTryDifferentNumber(): void;
  onTryAgain(): void;
  phoneNumber?: string;
  disabled?: boolean;
  error?: boolean;
  errorMessage?: string | null;
  loading?: boolean;
  visible: boolean;
  resetError: () => void;
}

export const ValidatePhoneNumber: FC<ValidatePhoneNumberProps> = (props) => {
  const [code, setCode] = React.useState('');
  const [buttonDisabled, setButtonDisabled] = React.useState(true);
  const [showSuccess, setShowSuccess] = React.useState(false);

  function handleCodeComplete(code: string) {
    props.resetError();
    setCode(code);
  }

  useEffect(() => {
    if (code && code.length === 6) {
      setButtonDisabled(false);
      return;
    }
    setButtonDisabled(true);
  }, [code]);

  return (
    <>
      <Dialog open={props.visible} fullScreen>
        <Box marginTop={5} textAlign={'center'}>
          <Grid display={'flex'} flexDirection={'column'} gap={4}>
            <Container>
              <img src={msg} alt={'message'} />
            </Container>
            <Typography color={'textPrimary'} fontSize={18} fontWeight={500}>
              Enter the code to confirm your number
            </Typography>

            <ValidationCode
              onCodeComplete={handleCodeComplete}
              error={props.error}
              errorMessage={props.errorMessage}
            ></ValidationCode>
          </Grid>
          <Grid marginLeft={4} marginRight={4} marginTop={4}>
            <Button disabled={buttonDisabled} fullWidth variant={'contained'} onClick={() => props.validateCode(code)}>
              Verify Code
            </Button>
          </Grid>
          <Typography lineHeight={1.5} sx={{ color: '#9d9d9d' }}>
            Didn&apos;t receive a code?{' '}
            <Link
              href={'#'}
              sx={{ textDecoration: 'underline', marginLeft: 0 }}
              onClick={() => {
                props.onResendCode();
                setShowSuccess(true);
              }}
            >
              Resend Code
            </Link>{' '}
          </Typography>
          <Box marginTop={4} marginRight={4} marginLeft={4}>
            <Link href={'#'} fontSize={12} sx={{ textDecoration: 'underline' }} onClick={props.onTryDifferentNumber}>
              Try using a different number
            </Link>
          </Box>
        </Box>
        <Snackbar
          open={showSuccess}
          onClose={() => setShowSuccess(false)}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert variant={'filled'} severity="success" sx={{ fontFamily: 'Roboto' }}>
            New verification code has been sent to {props.phoneNumber || 'your phone number'}
          </Alert>
        </Snackbar>
      </Dialog>
    </>
  );
};
